import { render, staticRenderFns } from "./details.vue?vue&type=template&id=63ce2c2a&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=63ce2c2a&prod&scoped=true&lang=less&"
import style1 from "./details.vue?vue&type=style&index=1&id=63ce2c2a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce2c2a",
  null
  
)

export default component.exports